import React, { Fragment } from 'react';
import ConsultantTalentCard from '../ConsultantTalentContainer/ConsultantTalentCard/ConsultantTalentCard';
import emptyTalentPageGraphic from '../../../assets/images/empty_my_talent_graphic.png';
import '../ConsultantTalentContainer/ConsultantTalentCard/ConsultantTalentCard.scss';
function UserFavorites(_ref) {
  var userFavorites = _ref.userFavorites;
  if (userFavorites.length === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "empty-consultant-talent-container style-guide d-flex justify-content-center align-items-center flex-column"
    }, /*#__PURE__*/React.createElement("p", {
      className: "normal-weight"
    }, "Access your fovorite consultants' information here."), /*#__PURE__*/React.createElement("p", {
      className: "normal-weight"
    }, "Once you save a consultant, they will appear on this page."), /*#__PURE__*/React.createElement("img", {
      src: emptyTalentPageGraphic,
      className: "empty-talent-graphic mt-5",
      alt: "Scientist Graphic"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "consultant-talent-container"
  }, userFavorites.map(function (consultant) {
    return /*#__PURE__*/React.createElement(ConsultantTalentCard, {
      key: consultant.id,
      id: consultant.resource_id,
      consultant: consultant
    });
  }));
}
export default UserFavorites;